export default __webpack_public_path__ + "static/media/cartel_provisional_elkano.e4816178.jpg";